import * as yup from 'yup';

export const userDetailsSchema = yup.object().shape({
  name: yup.string().required('El nombre es requerido'),
  email: yup
    .string()
    .email('El email es inválido')
    .required('El email es requerido'),
  gender: yup.string().required('El género es requerido'),
  birthday: yup.string().nullable(),
  status: yup.string().required('El status es requerido'),
  password: yup.string().notRequired(),
});

export const userExtraDetailsSchema = yup.object().shape({
  address: yup.string().notRequired(),
  external_number: yup.string().notRequired(),
  internal_number: yup.string().notRequired(),
  address1: yup.string().notRequired(),
  city: yup.string().notRequired(),
  state: yup.string().notRequired(),
  country: yup.string().notRequired(),
  postal_code: yup.string().notRequired(),
  phone: yup.string().notRequired(),
  phone1: yup.string().notRequired(),
  interests: yup.array(yup.string().notRequired()).notRequired(),
  wppbroadcastChannel: yup.boolean().notRequired(),
});